import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Youtube, Linkedin } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const infoLinks = [
    { key: 'footer.faq', path: '/info/faq' },
    { key: 'footer.routes', path: '/info/routes' },
    { key: 'footer.contacts', path: '/info/contacts' },
    { key: 'footer.about', path: '/info/about' },
    { key: 'footer.career', path: '/info/career' },
    { key: 'footer.businessService', path: '/info/business' },
  ];

  const docLinks = [
    { key: 'footer.privacy', path: '/info/privacy' },
    { key: 'footer.salesTerms', path: '/info/terms' },
    { key: 'footer.customs', path: '/info/customs' },
    { key: 'footer.transportRules', path: '/info/transport' },
  ];

  const socialLinks = [
    { icon: Facebook, url: 'https://www.facebook.com/luxexpress' },
    { icon: Instagram, url: 'https://www.instagram.com/luxexpress' },
    { icon: Youtube, url: 'https://www.youtube.com/@luxexpress' },
    { icon: Linkedin, url: 'https://www.linkedin.com/company/lux-express' },
  ];

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    setSubscribed(true);
    setEmail('');
    setTimeout(() => setSubscribed(false), 3000);
  };

  return (
    <footer className="bg-[#4a4d56] text-white/80 pt-8 md:pt-12 pb-6">
      <div className="max-w-[1280px] mx-auto px-3 md:px-4">
        <div className="flex items-center gap-1 mb-6 md:hidden">
          <span className="text-2xl text-white italic" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 800, letterSpacing: '0.02em' }}>LUX</span>
          <span className="text-sm text-white/80 italic ml-0.5" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 600, letterSpacing: '0.02em' }}>Express</span>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 mb-6 md:mb-10">
          <div className="hidden md:block">
            <div className="flex items-center gap-1 mb-6">
              <span className="text-2xl font-extrabold text-white">LUX</span>
              <span className="text-sm font-medium text-white/60">Express</span>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">{t('footer.info')}</h4>
            <ul className="space-y-2">
              {infoLinks.map((item) => (
                <li key={item.key}>
                  <Link to={item.path} className="text-sm text-white/60 hover:text-white transition-colors">
                    {t(item.key)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">{t('footer.docs')}</h4>
            <ul className="space-y-2">
              {docLinks.map((item) => (
                <li key={item.key}>
                  <Link to={item.path} className="text-sm text-white/60 hover:text-white transition-colors">
                    {t(item.key)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-2 md:col-span-1">
            <h4 className="text-white font-semibold text-sm mb-4">{t('footer.follow')}</h4>
            <div className="flex gap-3 mb-6">
              {socialLinks.map(({ icon: Icon, url }) => (
                <a key={url} href={url} target="_blank" rel="noopener noreferrer">
                  <Icon size={18} className="text-white/60 hover:text-white cursor-pointer transition-colors" />
                </a>
              ))}
            </div>

            <h4 className="text-white font-semibold text-sm mb-3">{t('footer.subscribe')}</h4>
            {subscribed ? (
              <p className="text-sm text-[#2e9e5a] font-semibold">✓ OK</p>
            ) : (
              <form onSubmit={handleSubscribe} className="flex">
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t('footer.emailPlaceholder')}
                  className="bg-white/10 border border-white/20 rounded-l px-3 py-2 text-sm text-white placeholder-white/40 flex-1 outline-none focus:border-white/40"
                />
                <button
                  type="submit"
                  className="bg-[#c30909] text-white text-[14px] font-semibold px-4 py-2 rounded-r hover:bg-[#a00707] transition-colors uppercase tracking-wider"
                >
                  {t('footer.join')}
                </button>
              </form>
            )}
          </div>
        </div>

        <div className="border-t border-white/10 pt-4 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">© 2026 Lux Express</p>
          <div className="flex items-center gap-3">
            {/* Mastercard */}
            <div className="flex items-center gap-0">
              <svg width="40" height="26" viewBox="0 0 40 26" fill="none">
                <circle cx="14" cy="13" r="10" fill="#555" fillOpacity="0.8"/>
                <circle cx="26" cy="13" r="10" fill="#888" fillOpacity="0.7"/>
              </svg>
            </div>
            {/* Visa */}
            <div>
              <span className="text-white/80 font-bold text-lg tracking-wider" style={{ fontFamily: "'Inter', sans-serif" }}>VISA</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
